<template>
  <div class="layout">
    <div class="top-layout">
      <div class="top-base-view" :style="{color:color}">
        <div class="top-layout-con">
          <div class="top-wrap">
            <div class="logo">
              <img src="../assets/images/logo.png" />亿实少儿编程
            </div>
            <div class="mune-layout">
              <a :href="host" target="_blank" :style="{color:color}" class="mune-node">创作平台</a>
              <!-- <a href="javascript:;" class="mune-node">作品展示</a> -->
            </div>
            <div v-if="!islogin" class="login">
              <a href="javascript:;" @click="login" :style="{color:color}">登录</a>
              <a
                href="javascript:;"
                @click="register"
                style="margin-left:30px"
                :style="{color:color}"
              >注册</a>
            </div>
            <el-dropdown v-if="islogin" class="login" @command="handleCommand">
              <div>
                <a href="javascript:;" :style="{color:color}">{{userinfo.name}}</a>
                <a
                  href="javascript:;"
                  style="margin-left:30px"
                  :style="{color:color}"
                >{{userinfo.aid}}</a>
                <i class="el-icon-caret-bottom" style="margin-left:10px" :style="{color:color}"></i>
                <!-- <a 	href="javascript:;" style="margin-left:30px" :style="{color:color}" @click="loginOut">注销</a> -->
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="1">个人信息</el-dropdown-item>
                <el-dropdown-item :command="4">课程选择</el-dropdown-item>
                <el-dropdown-item :command="2">修改密码</el-dropdown-item>
                <el-dropdown-item :command="3">注销</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="banner-layout">
        <el-carousel height="500px" @change="carouselchang">
          <el-carousel-item>
            <div class="slidebox">
              <div class="sliders">
                <img src="../assets/images/3.png" />
                <img src="../assets/images/4.png" />
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="slidebox slidebox-1">
              <div class="sliders">
                <img src="../assets/images/2.png" />
                <img src="../assets/images/1.png" />
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="conent-layout">
      <!-- 搜索以及标签 -->
      <div class="ms-layout">
        <div class="ms-l" style="margin-top: 14px;">
          <span :class="{active: status=='new'}" @click="project('new')">最新</span>
          <!-- <span>精选</span> -->
          <span v-if="islogin" :class="{active: status=='class'}" @click="project('class')">班级</span>
          <span v-if="islogin" :class="{active: status=='my'}" @click="project('my')">我的</span>
        </div>
        <div class="ms-r">
          <!-- <div class="ms-1"><i class="iconfont icon-dingwei"></i>厦门市</div>
          <div class="ms-2"><i class="iconfont icon-biyegraduation"></i>集美小学</div>-->
          <div class="ms-3">
            <el-select
              v-if="status=='class'"
              v-model="eid"
              placeholder="选择学校"
              filterable
              style="margin-left:10px"
              size="small"
              clearable
              @change="schoolChange"
            >
              <el-option
                v-for="item in schoolList"
                :key="item.eid"
                :label="item.cname"
                :value="item.eid"
              />
            </el-select>
            <el-select
              v-if="status=='class'"
              v-model="classUid"
              placeholder="选择班级"
              filterable
              style="margin-left:10px"
              size="small"
              clearable
              @change="getAllList"
            >
              <el-option
                v-for="item in classList"
                :key="item.uid"
                :label="item.name"
                :value="item.uid"
              />
            </el-select>
            <el-input
              v-model="keywork"
              size="small"
              placeholder="请输入内容"
              style="width: 200px;margin: 0px 20px;line-height: 55px;"
            ></el-input>
            <el-button
              type="primary"
              size="small"
              @click="search"
              style="height: 30px;margin-top:14px"
            >搜索</el-button>
          </div>
        </div>
      </div>
      <!-- 作品列表 -->
      <div class="project-list">
        <div class="project-node" v-for="(item, idx) in lists" :key="idx">
          <div class="project-box">
            <img
              @click="jump(item.id)"
              :src="'https://yes-kids.com/cp/api/cms/resource/download/'+item.imgUid"
            />
            <div class="project-name">{{item.workName || ''}}</div>
            <!-- <div class="project-see"><i class="iconfont icon-yanjing"></i>1231</div> -->
          </div>
          <div class="project-auther">
            <span
              class="auther-i"
            >{{item.cname ==null || item.cname == '平台'? '':item.className ==null? '('+item.cname+')':'('+item.cname+'-'+item.className+')'}}{{item.createrName || ''}}</span>
            <span class="auther-e" v-if="status=='my'" @click="toproject(item.id, item.isPerfect)">
              <i class="iconfont icon-bianji"></i>编辑
            </span>
            <span
              class="auther-e"
              style="color:red;margin-left:10px"
              v-if="status=='my'"
              @click="delwork(item.uid, item.isPerfect)"
            >
              <i class="iconfont icon-shanchu"></i>删除
            </span>
          </div>
        </div>
      </div>
      <!-- 分页 -->
      <div class="data-page">
        <el-pagination
          @size-change="getSelfList"
          @current-change="getAllList"
          :current-page.sync="currentPage"
          :page-size="size"
          :page-sizes="pageSizes"
          layout="sizes, total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <foot />

    <!-- 登陆 -->
    <div class="login-marker" v-if="ispop"></div>
    <div class="login-layout" v-if="ispop">
      <div class="login-tit">登陆</div>
      <div class="login-conent">
        <div class="login-label">
          账号 ：
          <input type="text" v-model="username" placeholder="请输入账号" />
        </div>
        <div class="login-label">
          密码 ：
          <input type="password" v-model="password" placeholder="请输入密码" />
        </div>
        <div class="login-btn">
          <button class="btn cancel" @click="popsd">取消</button>
          <button class="btn" @click="loginsub">确定</button>
        </div>
      </div>
    </div>

    <!-- 注册 -->
    <div class="login-marker" v-if="registerShow"></div>
    <div
      class="login-layout"
      v-if="registerShow"
      style="width: 600px;margin-left: -300px;top:20%;height: 700px;"
    >
      <div class="login-tit">注册</div>
      <div class="login-conent">
        <div class="login-label">
          *学生姓名 ：
          <input type="text" v-model="registerForm.name" placeholder="请输入" />
        </div>
        <div class="login-label">
          *家长姓名1 ：
          <input type="text" v-model="registerForm.parentName1" placeholder="请输入" />
        </div>
        <div class="login-label">
          *家长手机1 ：
          <input type="text" v-model="registerForm.parentTel1" placeholder="请输入" />
        </div>
        <div class="login-label">
          家长姓名2 ：
          <input type="text" v-model="registerForm.parentName2" placeholder="请输入" />
        </div>
        <div class="login-label">
          家长手机2 ：
          <input type="text" v-model="registerForm.parentTel2" placeholder="请输入" />
        </div>
        <div v-if="registerPopType == 0" class="login-label">
          *登录密码 ：
          <input type="password" v-model="registerForm.password" placeholder="请输入" />
        </div>
        <div class="login-label" style="display: flex;margin-left: 160px;margin-top: -10px">
          <span style="margin-top: 17px;">区域选择：</span>
          <AreaSelect @change="areaChage" :editdata="editAreadata" />
        </div>
        <div class="login-label">
          详细地址 ：
          <input type="text" v-model="registerForm.address" placeholder="请输入" />
        </div>
        <div class="login-btn">
          <button class="btn cancel" @click="register">取消</button>
          <button class="btn" @click="registersub">确定</button>
        </div>
      </div>
    </div>

    <!-- 修改密码 -->
    <div class="login-marker" v-if="changePwdShow"></div>
    <div class="login-layout" v-if="changePwdShow" style="height:300px">
      <div class="login-tit">修改密码</div>
      <div class="login-conent">
        <div class="login-label">
          旧密码 ：
          <input type="password" v-model="oldPwd" placeholder="请输入旧密码" />
        </div>
        <div class="login-label">
          新密码 ：
          <input type="password" v-model="newPwd" placeholder="请输入新密码" />
        </div>
        <div class="login-label">
          密码确认：
          <input type="password" v-model="pwdConform" placeholder="请输入确认密码" />
        </div>
        <div class="login-btn">
          <button class="btn cancel" @click="chagePwdPop">取消</button>
          <button class="btn" @click="changePwd">确定</button>
        </div>
      </div>
    </div>

    <el-dialog title="课程选择" :visible.sync="isclass" width="80%" :show-close="false">
      <div class="kecheng">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="已完成" name="first">
            <div class="plist">
              <div class="pbox" v-for="(item, index) in studentlist" :key="index">
                <div class="pname">
                  作品名称：
                  <span style="color: red">{{item.name}}</span>
                </div>
                <div class="pject">作品介绍：{{item.introduce}}</div>
                <div class="pname">班级：{{item.className}}</div>
                <div style="margin-top:10px">
                  <el-button type="primary" size="mini" @click="jumpcalss(item)">开始学习</el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    v-if="item.meetId!=null"
                    @click="jumpol(item)"
                  >在线学习</el-button>
                </div>
              </div>
            </div>
            <div style="margin-top:20px">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="spage"
                :page-sizes="[4, 8, 12]"
                :page-size="ssize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              ></el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="未完成" name="second">
            <div class="plist">
              <div class="pbox" v-for="(item, index) in studentlist" :key="index">
                <div class="pname">
                  作品名称：
                  <span style="color: red">{{item.name}}</span>
                </div>
                <div class="pject">作品介绍：{{item.introduce}}</div>
                <div class="pname">班级：{{item.className}}</div>
                <div style="margin-top:10px">
                  <el-button type="primary" size="mini" @click="jumpcalss(item)">开始学习</el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    v-if="item.meetId!=null"
                    @click="jumpol(item)"
                  >在线学习</el-button>
                </div>
              </div>
            </div>
            <div style="margin-top:20px">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="spage"
                :page-sizes="[4, 8, 12]"
                :page-size="ssize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              ></el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isclass = false">关 闭</el-button>
        <!-- <el-button type="primary" @click="classsub">确 定</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
// import moment from "moment";
import {
  Input,
  Button,
  Pagination,
  Carousel,
  CarouselItem,
  Select,
  MessageBox,
  Dialog,
  Message
} from "element-ui";
Vue.use(Input)
  .use(Button)
  .use(Pagination)
  .use(Carousel)
  .use(CarouselItem)
  .use(Select)
  .use(Dialog);
import AreaSelect from "../components/Area";
import Foot from "../components/foot";
import Api from "../api.js";
const api = new Api();

export default {
  name: "home",
  components: {
    Foot,
    AreaSelect
  },

  data() {
    return {
      // host: "http://localhost:8085/",
      host: "https://yes-kids.com/cp/gui/",
      player: "https://yes-kids.com/cp/player/",
      ispop: false,
      islogin: false,
      registerShow: false,
      userinfo: {},
      password: "",
      username: "",
      currentPage: 1,
      page: [],
      keywork: "",
      total: 0,
      size: 12,
      pageSizes: [12, 24, 36],
      lists: [],
      listsx: [],
      status: "new",
      color: "#fff",
      registerForm: {},
      eid: "",
      classUid: "",
      schoolList: [],
      classList: [],
      changePwdShow: false,
      oldPwd: "",
      newPwd: "",
      pwdConform: "",
      registerPopType: 0, // 0代表注册，1代表修改,
      editAreadata: {},
      isclass: false,
      spage: 1,
      ssize: 8,
      isFinish: "Y",
      activeName: "first",
      studentlist: [],
      total: 0
    };
  },

  computed: {},

  methods: {
    async handleClick(tab, event) {
      // console.log(tab, event);
      if (tab.index == "0") {
        this.isFinish = "Y";
      } else if (tab.index == "1") {
        this.isFinish = "N";
      }
      await this.getStudent();
    },
    jumpcalss(item) {
      window.open(`${this.host}#class_${item.uid}`);
      // window.location.href = `${this.host}#${id}`;
    },
    jumpol(item) {
      if (item.meetId == null || item.meetId == "") {
        return false;
      }
      window.open(`https://zoom.com.cn/j/${item.meetId}`);
    },
    handleClose() {},
    // 下拉菜单
    async handleCommand(val) {
      if (val == 1) {
        this.register(1);
      }
      if (val == 2) {
        this.chagePwdPop();
      }
      if (val == 3) {
        this.loginOut();
      }
      if (val == 4) {
        this.classSelect();
        await this.getStudent();
      }
    },
    classsub() {},
    classSelect() {
      this.isclass = true;
    },
    async getStudent() {
      const data = {
        keyword: null,
        classUid: null,
        isFinish: this.isFinish
      };
      const res = await api.queryByStudent(data, this.spage - 1, this.ssize);
      console.log("课程：", res);
      this.studentlist = res.content;
      this.total = res.totalElements;
    },
    async handleSizeChange(size) {
      this.ssize = size;
      this.getStudent();
    },
    async handleCurrentChange(page) {
      this.spage = page;
      this.getStudent();
    },
    // 修改密码弹窗
    chagePwdPop() {
      this.changePwdShow = !this.changePwdShow;
    },
    // 修改密码
    async changePwd() {
      if (this.oldPwd == "" || this.oldPwd == undefined) {
        Message("请输入旧密码");
        return;
      }
      if (this.newPwd == "" || this.newPwd == undefined) {
        Message("请输入新密码");
        return;
      }
      if (
        this.pwdConform == "" ||
        this.pwdConform == undefined ||
        this.newPwd != this.pwdConform
      ) {
        Message("两次密码不一样");
        return;
      }
      await api.changePwdAjax(this.oldPwd, this.newPwd);
      Message({
        message: "修改成功",
        type: "success"
      });
      this.chagePwdPop();
    },
    // 学校下拉数据
    async getAllSchool() {
      this.schoolList = await api.queryAllSchool();
    },
    // 选择学校
    async schoolChange(data) {
      console.log(data);
      this.classList = await api.getClassList(data);
      this.getAllList();
    },
    carouselchang(num) {
      if (num == 0) {
        this.color = "#fff";
      } else if (num == 1) {
        this.color = "#000";
      } else {
        this.color = "#fff";
      }
    },
    areaChage(val) {
      this.registerForm.areaL1Code = val.areaL1Code;
      this.registerForm.areaL2Code = val.areaL2Code;
      this.registerForm.areaL3Code = val.areaL3Code;
      this.registerForm.areaL1Name = val.areaL1Name;
      this.registerForm.areaL2Name = val.areaL2Name;
      this.registerForm.areaL3Name = val.areaL3Name;
    },
    toproject(id, isPerfect) {
      if (isPerfect) {
        MessageBox.alert(
          "本作品为精选作品,暂不支持修改删除,是否还继续进入编辑页面",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            showCancelButton: true,
            callback: action => {
              if (action == "confirm") {
                window.location.href = `${this.host}#${id}`;
              }
            }
          }
        );
      } else {
        window.location.href = `${this.host}#${id}`;
      }
    },
    async delwork(uid, isPerfect) {
      const that = this;
      if (isPerfect) {
        Message.error("本作品为精选作品,暂不支持删除");
      } else {
        MessageBox.alert("确定删除本作品吗?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showCancelButton: true,
          callback: async action => {
            if (action == "confirm") {
              await api.delWorkEntity(uid);
              Message({
                message: "删除成功",
                type: "success"
              });
              that.getAllList();
            }
          }
        });
      }
    },
    async project(data) {
      this.status = data;
      this.currentPage = 1;
      await this.getAllList();
    },
    async myprofile() {
      this.userinfo = await api.profile();
      if (this.userinfo != null && this.userinfo.aid) {
        localStorage.setItem("editAid", this.userinfo.aid);
        this.islogin = true;
      } else {
        // this.popsd()
      }
    },
    async getSelfList() {
      const res = await api.selfList(this.currentPage - 1);
      this.lists = res.content;
      this.total = res.totalElements;
    },
    async getAllList() {
      let res;
      if (this.status == "new") {
        res = await api.allList(
          { keyword: this.keywork, isPerfect: true },
          this.currentPage - 1
        );
      } else if (this.status == "my") {
        res = await api.selfList(
          { keyword: this.keywork },
          this.currentPage - 1
        );
      } else if (this.status == "class") {
        res = await api.allBySchool(
          { keyword: this.keywork, eid: this.eid, classUid: this.classUid },
          this.currentPage - 1
        );
      }
      this.lists = res.content;
      this.total = res.totalElements;
    },
    search() {
      this.getAllList();
    },
    popsd() {
      this.ispop = this.ispop ? false : true;
    },
    async loginsub() {
      const t = this;
      t.userinfo = await api.login({ id: t.username, password: t.password });
      if (t.userinfo.aid) {
        this.popsd();
        this.islogin = true;
        await this.myprofile();
        await this.getAllSchool();
        this.getAllList();
      }
    },
    async registersub() {
      if (this.registerForm.name == "" || this.registerForm.name == undefined) {
        Message("请输入学生姓名");
        return;
      }
      if (
        this.registerForm.parentName1 == "" ||
        this.registerForm.parentName1 == undefined
      ) {
        Message("请输入家长姓名1");
        return;
      }
      if (
        this.registerForm.parentTel1 == "" ||
        this.registerForm.parentTel1 == undefined
      ) {
        Message("请输入家长手机1");
        return;
      }
      if (
        !(
          /^[1][3,4,5,7,8][0-9]{9}$/.test(this.registerForm.parentTel1) ||
          /^(\+?852\-?)?[569]\d{3}\-?\d{4}$/.test(this.registerForm.parentTel1)
        )
      ) {
        Message("请先输入正确手机号码");
        return;
      }
      if (
        this.registerPopType == 0 &&
        (this.registerForm.password == "" ||
          this.registerForm.password == undefined)
      ) {
        Message("请输入密码");
        return;
      }
      if (this.registerPopType == 0) {
        const res = await api.register(this.registerForm);
        MessageBox.alert("您的登入账号为:" + res, "注册成功", {
          confirmButtonText: "确定",
          callback: action => {
            console.log(action);
          }
        });
      }
      if (this.registerPopType == 1) {
        const res = await api.updataAccountInfo(this.registerForm);
        if (res) {
          Message({
            message: "修改成功",
            type: "success"
          });
        }
      }

      this.register();
    },
    login() {
      this.popsd();
    },
    async register(type) {
      this.registerShow = !this.registerShow;
      this.registerForm = {};
      this.registerPopType = 0;
      this.editAreadata = {};
      if (type == 1) {
        this.registerPopType = type;
        this.registerForm = await api.getAccountInfo();
        this.editAreadata = {
          code1: this.registerForm.areaL1Code,
          code2: this.registerForm.areaL2Code,
          code3: this.registerForm.areaL3Code
        };
      }
    },
    jump(id) {
      window.open(`${this.player}index.html#project/${id}`);
      // this.$router.push({path:'play'})
    },

    async loginOut() {
      const that = this;
      MessageBox.alert("确定注销当前登入账号吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showCancelButton: true,
        callback: async action => {
          if (action == "confirm") {
            await api.loginOut();
            that.islogin = false;
            that.status = "new";
            that.getAllList();
            await that.getAllSchool();
            await that.myprofile();
          }
        }
      });
    }
  },
  mounted: async function() {
    document.title = "亿实少儿编程";
    await this.getAllList();
    await this.myprofile();
    await this.getAllSchool();
  }
};
</script>

<style>
#app {
  height: 100%;
  background-color: #fff;
}
html,
body {
  background-color: #fff;
  height: 100%;
}
.data-page .el-select {
  line-height: 28px;
}
</style>

<style lang="less" scoped>
.plist {
  display: flex;
  .pbox {
    width: 25%;
    padding-right: 10px;
    .pname {
      font-size: 14px;
      margin-top: 4px;
    }
    .pject {
      font-size: 14px;
      margin-top: 4px;
      // display: flex;
      // -webkit-box-orient: vertical;
      // -webkit-line-clamp: 1;
      height: 60px;
      overflow: hidden;
    }
  }
}
.kecheng_nav {
  display: flex;
}
.login-marker {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.5;
  z-index: 990;
}
.login-layout {
  position: fixed;
  left: 50%;
  width: 400px;
  margin-left: -200px;
  top: 50%;
  margin-top: -120px;
  height: 240px;
  background-color: #fff;
  border-radius: 5px;
  z-index: 999;
  .login-tit {
    font-size: 16px;
    padding: 10px 20px;
  }
  .login-conent {
    .login-label {
      padding: 10px 0;
      text-align: center;
      input {
        border: 1px solid #ddd;
        height: 30px;
        line-height: 30px;
        border-radius: 3px;
        width: 200px;
      }
    }
    .login-btn {
      text-align: center;
      margin: 20px 0 0 0;
      .btn {
        border: 0px;
        font-size: 14px;
        height: 40px;
        line-height: 40px;
        background-color: #4aa9f7;
        color: #fff;
        border-radius: 3px;
        width: 80px;
        margin: 0 10px;
      }
      .cancel {
        background-color: white;
        border: 1px solid #dcdfe6;
        color: black;
      }
    }
  }
}
.layout {
  background-color: #fff;
  font-size: 14px;
  height: 100%;
  .top-layout {
    box-shadow: 2px 2px 2px #f0f0f0;
    position: relative;
    height: 500px;
    .top-base-view {
      position: absolute;
      top: 0px;
      left: 0%;
      width: 100%;
      z-index: 1111;
      // background-color: #4d97ff;
    }
    .top-layout-con {
      width: 1230px;
      margin: 0 auto;
      .top-wrap {
        display: flex;
        line-height: 45px;
        margin-top: 25px;
        .logo {
          font-size: 20px;
          // color: #fff;
          img {
            width: 60px;
            height: 50px;
            vertical-align: -3px;
            margin: -10px 10px;
          }
        }
        .mune-layout {
          display: flex;
          margin-left: 40px;
          a {
            color: #fff;
          }
          .mune-node {
            margin-left: 20px;
            font-size: 16px;
            // color: #fff;
          }
        }
        .login {
          flex: 1;
          text-align: right;
          a {
            font-size: 14px;
            // color: #fff;
          }
        }
      }
    }
    .banner-layout {
      // justify-content: center;
      // align-items: center;
      // display: flex;
      height: 500px;
      font-size: 32px;
      color: #fff;
    }
  }
  .conent-layout {
    width: 1230px;
    margin: 0 auto;
    .ms-layout {
      display: flex;
      margin: 20px 0 0 0;
      .ms-l {
        flex: 1;
        display: flex;
        span {
          display: block;
          width: 60px;
          height: 30px;
          line-height: 30px;
          font-size: 12px;
          border: 1px solid #ddd;
          color: #9b9b9b;
          text-align: center;
          border-radius: 3px;
          margin-right: 15px;
          cursor: pointer;
        }
        span.active {
          background-color: #1a9bfc;
          color: #fff;
          border: 1px solid #1a9bfc;
        }
      }
      .ms-r {
        text-align: right;
        display: flex;
        color: #4aa9f7;
        line-height: 32px;
        .ms-1 {
        }
        .ms-2 {
          margin: 0 15px;
          i.iconfont {
            font-size: 24px;
            vertical-align: -4px;
          }
        }
        .ms-3 {
          display: flex;
        }
      }
    }
    .project-list {
      margin: 10px 0 0 0;
      display: flex;
      flex-flow: wrap;
      .project-node {
        border-radius: 5px;
        box-shadow: 0px 0px 7px #4caef8;
        width: 295px;
        margin-right: 15px;
        margin-top: 20px;
        .project-box {
          padding: 10px 10px 5px 10px;
          border-bottom: 1px solid #ddd;
          img {
            display: block;
            height: 210px;
            margin: 0 auto;
            width: 100%;
          }
          .project-name {
            margin: 10px 0 0 0;
            color: #333;
          }
          .project-see {
            margin: 5px 0 0 0;
            color: #999;
            i.iconfont {
              margin-right: 5px;
              font-size: 18px;
              vertical-align: -2px;
            }
          }
        }
        .project-auther {
          display: flex;
          padding: 10px;
          .auther-i {
            flex: 1;
            color: #333;
          }
          .auther-e {
            color: #4aa9f7;
            i.iconfont {
              margin-right: 4px;
              font-size: 18px;
              vertical-align: -2px;
            }
          }
        }
      }
      .project-node:nth-child(4n) {
        margin-right: 0;
      }
    }
    .data-page {
      margin: 30px auto;
      text-align: center;
    }
  }
}
.slidebox {
  background-image: url("../assets/images/5.png");
  background-size: cover;
  height: 500px;
  .sliders {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    padding: 50px 0;
    img:first-child {
      position: absolute;
      left: 140px;
      top: 200px;
    }
    img:last-child {
      position: absolute;
      right: 0px;
      top: 70px;
    }
  }
}
.slidebox-1 {
  background-image: none;
  background-size: cover;
  height: 500px;
  .sliders {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    padding: 50px 0;
    img:first-child {
      position: absolute;
      left: 140px;
      top: 200px;
    }
    img:last-child {
      position: absolute;
      right: 60px;
      top: 70px;
    }
  }
}
</style>

